// Pure reducer for the Copilot activity trail: turns a stream of
// {id, label, status} events - gitcha-mcp's `activity` SSE event, relayed
// unchanged through Gitcha-API - into an ordered list of steps for ONE
// assistant turn. No React here on purpose, so this is testable without a
// component-testing framework (see HelpChatPanel.js for how the per-turn
// steps array is threaded through `messages` - a fresh array per assistant
// turn, never shared across turns).
export const APPLY_ACTIVITY_FALLBACK_LABEL = "Working on it";

export const applyActivityEvent = (steps, event) => {
  if (!event || typeof event.id !== "string" || typeof event.status !== "string") {
    return steps;
  }
  const label =
    typeof event.label === "string" && event.label
      ? event.label
      : APPLY_ACTIVITY_FALLBACK_LABEL;
  const index = steps.findIndex((s) => s.id === event.id);

  if (event.status === "start") {
    if (index !== -1) return steps; // duplicate start for the same id, ignore
    return [...steps, { id: event.id, label, status: "start" }];
  }

  // "done" | "error" | anything else past start: update the matching step in
  // place. A done/error with no matching start (a dropped/reordered event -
  // shouldn't happen given the queue is FIFO, but never silently lose a real
  // update) appends a step directly rather than being discarded.
  if (index === -1) {
    return [...steps, { id: event.id, label, status: event.status }];
  }
  const next = [...steps];
  next[index] = { ...next[index], label, status: event.status };
  return next;
};
